import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "el-text__primary" }, " Manage Columns ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Add/Remove columns & Drag to re-order", -1)
const _hoisted_3 = ["onDblclick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode(_component_el_form, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_autocomplete, {
              modelValue: _ctx.datasetQueryValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.datasetQueryValue) = $event)),
              "popper-append-to-body": true,
              "fetch-suggestions": _ctx.queryDataset,
              placeholder: "Please select the column",
              onSelect: _ctx.addColumn
            }, null, 8, ["modelValue", "fetch-suggestions", "onSelect"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_scrollbar, { "max-height": "250px" }, {
      default: _withCtx(() => [
        (_ctx.dimensions && _ctx.dimensions.length > 0)
          ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, {
                  xs: 24,
                  sm: 24,
                  md: 12,
                  lg: 12,
                  xl: 12
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_draggable, {
                      modelValue: _ctx.dimensions,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dimensions) = $event)),
                      onStart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drag=true)),
                      onEnd: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drag=false)),
                      onChange: _ctx.reorderColumns,
                      "item-key": "id"
                    }, {
                      item: _withCtx(({element}) => [
                        _createElementVNode("div", {
                          class: "el-bordered__input el-padding__left el-padding__right el-margin__small",
                          onDblclick: ($event: any) => (
                  _ctx.selectedColumnId = element.id, _ctx.selectedColumn = element.header_text
                )
                        }, [
                          _createVNode(_component_el_row, {
                            type: "flex",
                            justify: "space-between",
                            align: "middle",
                            gutter: 0,
                            class: "el-capitalize"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, _toDisplayString(element.header_text), 1),
                              _createElementVNode("div", null, [
                                _createVNode(_component_el_button, {
                                  type: "text",
                                  icon: "el-icon-close",
                                  class: "el-text__danger",
                                  onClick: ($event: any) => (_ctx.removeColumn(element.id))
                                }, null, 8, ["onClick"]),
                                _createVNode(_component_el_button, { type: "text" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "grip-vertical",
                                      class: "el-text__grey"
                                    })
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ], 40, _hoisted_3)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_empty, {
              key: 1,
              description: "No Columns found"
            }))
      ]),
      _: 1
    })
  ]))
}